<template>
  <div
    class="giving-statistics"
    :class="parentClasses"
  >
    <div class="giving-statistics-header px30 pt30 pb30">
      <router-link
        to="/dashboard"
        class="px-2 pt30"
      >
        <Close icon="back" />
      </router-link>
      <h3
        class="page-title font-bold text-28 text-white px-2 tracking-tight leading-tight"
      >
        {{ $t("Donations") }}
      </h3>
      <div class="px-2 flex justify-between justify-center items-center">
        <div>
          <h3
            class="font-bold text-28 pt-3 tracking-tight leading-tight text-white"
          >
            ${{ $getState("totalDonation") }}
          </h3>
          <p class="text-11 text-white font-bold">Total YTD Amount</p>
        </div>
        <div class="relative">
          <button
            @click="textSummaryOption = !textSummaryOption"
            class="flex items-center border text-white"
            :class="textSummaryClasses"
          >
            <p class="mr-2">Tax Summary</p>
            <img :src="`${$getState('appUrl')}/img/pwa/three-dots.svg`" />
          </button>
          <div v-if="textSummaryOption" class="text-summary-modal">
            <div class="relative">
              <img
                :src="`${$getState('appUrl')}/img/pwa/up-icon.png`"
                class="absolute up-icon"
              />
            </div>
            <ul class="text-summary-modal-options">
              <li>
                <a
                  class="flex items-center"
                  @click="taxSummary('month')"
                >
                  <span class="ml-2">Monthly Receipt</span>
                </a>
              </li>
              <li>
                <a
                  class="flex items-center"
                  @click="taxSummary('year')"
                >
                  <span class="ml-2">Summary Report</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal
      content="No Donations Found"
      btn-yes="OK"
      clas="w-2/5"
      btn-no=""
      @no="$setState('setConfirmModal', false)"
      @yes="$setState('setConfirmModal', false)"
    />
    <div class="giving-statistics-body bg-white">
      <div class="px-9 pt-3">
        <ul
          class="tabs-head w-full flex flex-nowrap relative mb-8"
          :class="tabClasses"
          ref="givingChooser"
        >
          <li class="tabs-head__item relative">
            <button
              v-ripple
              ref="roundUpsRef"
              type="button"
              class="tabs-head__btn tabs-head__btn_roundups text-14 font-bold tracking-tight w-full text-center"
              @click="activeTab = 'roundUps'"
            >
              {{ $t("RoundUps") }}
            </button>
          </li>
          <li class="tabs-head__item relative">
            <button
              v-ripple
              ref="donationsRef"
              type="button"
              class="tabs-head__btn tabs-head__btn_donations text-14 font-bold tracking-tight w-full text-center"
              @click="activeTab = 'donations'"
            >
              {{ $t("One-Time Gift") }}
            </button>
          </li>
          <li class="absolute tabs-head__bgr"></li>
        </ul>
				<DonationFilters 
          v-if="activeTab == 'roundUps'" 
          @set-filters="populateFilters" />

        <div class="roundUps" v-if="activeTab === 'roundUps'">
          <div
            class="round-ups fade-in-bottom"
            v-for="(item, index) in roundUps"
            :key="`round-up-${index}`"
          >
            <div
              class="round-ups__date text-center text-label text-14 font-bold tracking-normal p-2 flex justify-center items-center w-full mx-auto"
            >
              {{ item.date }}
            </div>
            <ul class="round-ups__list" v-if="item.data.length">
              <li
                v-for="(list, index) in item.data"
                :key="index"
                class="round-ups__list-item flex flex-nowrap pb-1 pt-4"
              >
                <div class="round-ups__left w-4/6">
                  <h4
                    class="text-text text-14 font-bold tracking-normal leading-tight"
                  >
                    ${{ list.amount }} {{ list.name }}
                  </h4>
                  <p class="text-cause_text text-12 tracking-normal">
                    {{
                      Array.isArray(list.category)
                        ? list.category.join(", ")
                        : list.category
                    }}
                  </p>
                </div>
                <div
                  class="round-ups__right text-14 text-label tracking-normal leading-tight font-bold text-right w-2/6"
                >
                  ${{ roundDonation(list.amount) }}
                </div>
              </li>
            </ul>
          </div>
          <InfiniteLoading 
            :call="fetchRoundups"  
            :infiniteId="roundupId"
            no-more="No More Roundups"
          />
        </div>
        <div class="one-time-gift" v-else>
          <div class="round-ups fade-in-bottom list">
            <ul class="round-ups__list round-ups__list_donations">
              <li
                v-for="list in donations"
                :key="`gift-${list.id}`"
                class="round-ups__list-item flex flex-nowrap pb-1 pt-5"
              >
                <div class="round-ups__left w-4/6">
                  <h4
                    class="text-text text-14 font-bold tracking-normal leading-tight mb-1"
                  >
                    {{ list.title }}
                  </h4>
                  <p
                    class="text-label text-14 tracking-normal leading-tight font-bold mb-1"
                  >
                    {{ list.date }}
                  </p>
                  <p class="text-cause_text text-12 tracking-normal">
                    {{ list.type_donation_text }}
                  </p>
                </div>
                <div
                  class="round-ups__right text-label text-14 tracking-normal leading-tight font-bold text-right w-2/6"
                >
                  $ {{ parseFloat(list.amount).toFixed(2) }}
                </div>
              </li>
              <InfiniteLoading 
                :call="fetchGifts"  
                :infiniteId="donationInfiniteId"
                no-more="No More Donation"
              />
            </ul>
          </div>
          <div class="give-extra-section">
            <Extra />
          </div>
        </div>
        <DateRangeModal  
          @download="download" />
      </div>
    </div>
    <Navigation :causeRedirectUrl="causeRedirectUrl" />
  </div>
</template>

<script>
import Extra from "../components/Giving/Extra_new.vue";
import DonationFilters from '../components/Giving/DonationFilters.vue'
import Navigation from "../components/Navigation/NewNavigation.vue";
import Close from "../components/UI/Close";
import ConfirmModal from '../components/Modal/ConfirmModal.vue';
import DateRangeModal from '../components/Giving/DateRangeModal.vue'
import InfiniteLoading from '../components/UI/InfiniteLoading.vue'
export default {
  name: "GivingStatistics",
  components: { 
		Close,
		DonationFilters,
		Extra,
		Navigation,
    ConfirmModal,
    DateRangeModal,
    InfiniteLoading
	},
  props: {
		clickHandler: {
			type: Object,
			default: () => {}
		}
	},

  data: function() {
    return {
      transactionsLoad: true,
      currentRefName: "roundUpsRef",
      activeTab: "roundUps",
      donations: [],
      donationType: '',
      roundUps: [],
      transactions: [],
      giftPage: 0,
      page: 0,
      transactionPage: 0,
      limit: 10,
      total_donation: 0,
      causeRedirectUrl: "",
      textSummaryOption: false,
			filters: null,
			roundupId: new Date().getMilliseconds(),
      donationInfiniteId: new Date().getMilliseconds(),
    };
  },

  computed: {
    isDynamic() {
      return this.$getState("corporation")["is"]
    },
		parentClasses () {
			return { 
				'giving-statistics-bg-color': !this.isDynamic 
			}
		},
		textSummaryClasses () {
			return {
				'btn-text-summary-bg-color': !this.isDynamic,
				'btn-text-summary': this.isDynamic
			}
		},
    params () {
      return `from_month=${this.filters.from_month}&from_year=${this.filters.from_year}&to_month=${this.filters.to_month}&to_year=${this.filters.to_year}`
    },
		monthlyDonationReceipt () {
			return `${this.$getState('appUrl')}/monthly-donation-receipt/${this.$getLocalStorage('thriveAppToken')}?${this.params}`
		},
		yearlyDonationReceipt () {
			return `${this.$getState('appUrl')}/yearly-donation-receipt/${this.$getLocalStorage('thriveAppToken')}?${this.params}`
		},
		tabClasses () {
			return {
				'active-tab-donations': this.activeTab === 'donations',
				'active-tab-round-ups': this.activeTab === 'roundUps'
			}
		},
		isMonth () {
			return this.filters && this.filters.month ? `&month=${this.filters.month}`: ''
		},
		isYear () {
			return this.filters && this.filters.year ? `&year=${this.filters.year}`: ''
		},
    isTotalDonation () {
      return this.total_donation != "0.00"
    }
  },
  created() {
    this.$checkAvatar(this.$user("has_avatar"));
  },

  mounted() {
    this.$scrollToTop();
    this.getUserNpos();
  },

  methods: {
    whichSummary (type) {
      return type == 'month' ? this.monthlyDonationReceipt : this.yearlyDonationReceipt
    },
    taxSummary (type) {
      this.donationType = type
      this.$setState('setDateRangeModal', true)
      // this.isTotalDonation ? this.$setState('setDateRangeModal', true) : this.$setState('setConfirmModal', true)
      this.textSummaryOption = !this.textSummaryOption
    },
    download (obj) {
      this.filters = obj
      document.location.href = this.whichSummary(this.donationType)
      this.$setState('setDateRangeModal', false)
    },
    roundDonation: function(val) {
      const roundUp = parseInt(this.$user("roundup_amount"));
      if (roundUp) {
        return (Math.ceil(val / roundUp) * roundUp - val).toFixed(2);
      }
      return 0;
    },
    async fetchGifts ($state) {
      const payload = {
        offset: this.giftPage * this.limit,
        limit: this.limit,
        activeTab: this.activeTab
      }
      const res = await this.$http.post('user/listgiving', payload)
      if(!res.status) return
      if( res.data && res.data.donations && !res.data.donations.length) {
        $state.complete();
        return
      }
      this.donations.push(...res.data.donations);
      this.giftPage += 1;
      $state.loaded();
    },
    async fetchRoundups ($state) {
			let offset = this.transactionPage * this.limit;
			const res = await this.$http.get(`user/transactions?offset=${offset}&limit=${this.limit}${this.isMonth}${this.isYear}`)
			if(!res.status) return
      if(res.data && res.data.transactions && !res.data.transactions.length) {
        $state.complete()
        this.filters = null // rest after data bcz on switching we want to have default one
        return
      }
			this.total_donation = res.data.total_donation;
			this.$setState("totalDonation", parseFloat(this.total_donation).toFixed(2));
			this.roundUps.push(...res.data.transactions)
			$state.loaded();
			this.transactionPage += 1;
    },
    causeUrl (data) {
      this.causeRedirectUrl = data.length ? `npos/${data[0]["id"]}` : "npos"
    },
    async getUserNpos () {
      const res = await this.$http.post("user/listnpo")
      if(!res.status) return
      if(res && res.data && !res.data.npo) return
      const causes = res.data.npo;
      this.causeUrl(causes);
    },
    async sendMail () {
      const res = this.$http.post("user/send_tax_report")
      if(!res.status) return
      this.textSummaryOption = !this.textSummaryOption;
    },
		populateFilters (obj) {
			this.filters = obj
			this.roundUps = []
			this.roundupId += 1
			this.transactionPage = 0
		}
  }
};
</script>
<style lang="scss">
.giving-statistics-bg-color {
  background-color: #324e58 !important;
}

.btn-text-summary-bg-color {
  padding: 10px 25px;
  border-radius: 30px;
  border: transparent;
  box-shadow: 0px 0px 8px #1a2326;
  background-color: var(--btn-text-summary);
}

.giving-statistics
  .giving-statistics-body
  .give-extra-section
  .giving-little-extra {
  background-color: var(--bg-color);
}

.giving-statistics
  .giving-statistics-body
  .give-extra-section
  .giving-chooser__btn {
  color: var(--sub-text-color);
}

.giving-statistics
  .give-extra-section
  .giving-little-extra
  .giving-chooser__btn.active-extra {
  background: var(--bg-color);
  border: 1px solid var(--bg-color);
  color: #ffffff;
}

.giving-statistics
  .giving-statistics-body
  .give-extra-section
  .giving-little-extra
  .btn {
  background: var(--btn-color);
  border: 1px solid transparent;
}

.giving-statistics
  .giving-statistics-body
  .give-extra-section
  .giving-little-extra
  .giving-chooser__custom {
  color: var(--sub-text-color);
}
</style>
